import React from "react";

export function UpArrowIcon(props) {
  return (
    <svg
      width="50.00000000000001"
      height="50.00000000000001"
      xmlns="http://www.w3.org/2000/svg"
      className="feather feather-arrow-up-circle"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="3"
      stroke="#634426"
      fill="none"
      {...props}
    >
      <g className="up-arrow-icon">
        <title>Layer 1</title>
        <g id="svg_18">
          <path
            stroke="null"
            id="svg_5"
            d="m26.33064,9"
            opacity="NaN"
            strokeWidth="3"
          />
          <circle
            stroke="null"
            fillOpacity="0"
            fill="#634426"
            strokeWidth="22"
            id="svg_1"
            r="9.67976"
            cy="25.878"
            cx="25"
          />
          <g id="svg_16">
            <polyline
              stroke="#d8b48b"
              strokeWidth="5"
              fill="#634426"
              id="svg_2"
              points="34.34257125854492,24.51803207397461 24.99998664855957,15.761383056640625 15.657435417175293,24.51803207397461 "
            />
            <line
              stroke="#d8b48b"
              strokeWidth="5"
              fill="#634426"
              id="svg_3"
              y2="18.48134"
              x2="25"
              y1="35.99462"
              x1="25"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function ImageIcon(props) {
  return (
    <svg
      width="300"
      height="200"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-image"
      {...props}
    >
      <g>
        <title>Layer 1</title>
        <g stroke="null" id="svg_4" strokeWidth="6">
          <rect
            stroke="#634426"
            x="34.60296"
            y="22.52334"
            width="230.79407"
            height="148.94695"
            rx="2"
            ry="2"
            id="svg_1"
          />
          <circle
            stroke="#634426"
            cx="105.12337"
            cy="68.0349"
            r="11.87127"
            id="svg_2"
          />
          <polyline
            stroke="#634426"
            points="265.3970413208008,121.82128143310547 201.28759002685547,80.44715881347656 60.246742248535156,171.4702911376953 "
            id="svg_3"
          />
        </g>
      </g>
    </svg>
  );
}

export function FailImageIcon(props) {
  return (
    <svg
      width="300"
      height="200"
      xmlns="http://www.w3.org/2000/svg"
      className="feather feather-image"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      {...props}
    >
      <g>
        <title>Layer 1</title>
        <g strokeWidth="6" id="svg_4" stroke="null">
          <rect
            id="svg_1"
            ry="2"
            rx="2"
            height="148.94695"
            width="230.79407"
            y="22.52334"
            x="34.60296"
            stroke="#fa1131"
          />
          <circle
            id="svg_2"
            r="11.87127"
            cy="68.0349"
            cx="105.12337"
            stroke="#fa1131"
          />
          <polyline
            id="svg_3"
            points="265.3970413208008,121.82128143310547 201.28759002685547,80.44715881347656 60.246742248535156,171.4702911376953 "
            stroke="#fa1131"
          />
        </g>
      </g>
    </svg>
  );
}
